import { store } from '../../index';
import { IDLE_STATUS } from '../../../utils/types/statuses';

export const checkCanLoadAvailable = (cb: () => void): void => {
  const { availableForAppearancesIn } = store.getState();
  if (availableForAppearancesIn.status === IDLE_STATUS) {
    cb();
  }
};
